
export default [
  {
    path: '/businessenter',
    name:'BusinessEnter',
    meta:{
      title:'我要入驻'
    },
    component: () => import('../views/BusinessEnter/BusinessEnter.vue')
  },
  {
    path: '/businessenter/complete',
    name:'BusinessEnterComplete',
    meta:{
      title:'我要入驻完成'
    },
    component: () => import('../views/BusinessEnter/BusinessEnterComplete.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/businessEnter.js